import { css } from '@/styled-system/css';

export const homeHubCSS = css({
  paddingTop: { base: '66px', md: '42px' },
});

export const homeHubHeroCSS = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export const homeHubSubheaderCSS = css({
  display: { base: 'none', md: 'block' },
});

export const homeHubSearchCSS = css({
  paddingTop: { base: '8px', md: '32px' },
  width: { base: '100%', md: 'unset' },
});

export const homeHubSectionsCSS = css({
  paddingTop: { base: '8px', md: '32px' },
  width: { base: '100%', md: 'unset' },
  '& hr': {
    height: '1px',
    opacity: '0.2',
  },
});

export const homeHubSectionTitleContainerCSS = css({
  marginTop: '24px',
  display: 'flex',
  justifyContent: 'space-between',
  paddingRight: '16px',
  flexFlow: 'row wrap',
  fontSize: '14px',
});

export const resumeSearchTextCSS = css({
  marginRight: '16px',
});

export const resumeSearchContainerCSS = css({
  display: 'flex',
  alignItems: { base: 'flex-start', md: 'center' },
  flexDirection: { base: 'column', md: 'row' },
  paddingTop: '8px',
  paddingRight: '0',
  paddingLeft: '0',
});

export const resumeSearchButtonContainerCSS = css({
  display: 'inline-block',
  margin: { base: '8px 0', md: '0' },
});

export const homeHubSectionTitleCSS = css({
  flex: 1,
  fontWeight: 'normal',
  fontSize: '14px',
  lineHeight: '20px',
});

export const homeHubCollectionsCSS = css({
  width: '100%',
});

export const homeHubCollectionsHeaderCSS = css({
  display: { base: 'none', md: 'block' },
});

export const homeHubAsideCSS = css({
  display: 'flex',
  flexDirection: { base: 'column', md: 'row' },
  width: '100%',
  gap: '16px',
  marginTop: '24px',
  minHeight: { base: '320px', md: '280px' },
});

export const homeHubExpandMySearchCSS = css({
  marginTop: '14px',
  marginRight: 'auto',
  marginBottom: '14px',
  marginLeft: 'auto',
  display: 'flex',
  flexWrap: 'wrap',

  '& img': {
    verticalAlign: 'bottom',
    marginRight: '8px',
    width: '16px',
  },
  '& a': {
    padding: '12px',
    marginRight: '16px',
    marginBottom: '16px',
    borderRadius: '4px',
    boxShadow: { base: '0 2px 4px 0 rgba(0, 0, 0, 0.1)', _hover: '0 8px 32px 0 rgba(0, 0, 0, 0.1)' },
    fontSize: '14px',
    color: 'hpxBlue600',
  },
});

export const expandMySearchCSS = css({
  width: { base: '100%', md: '50%' },
});

export const listingCollectionHeaderTextCSS = css({
  fontSize: 'lg',
  lineHeight: 'lg',
  fontWeight: 'bold',
});

export const fairHousingCSS = css({
  width: { base: '100%', md: '50%' },
});

export const fairHousingDisplayBlockCSS = css({
  display: 'block',
});

export const fairHousingIconContainerCSS = css({
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey500',
  borderRadius: '50%',
  marginTop: '0',
  marginRight: 'auto',
  marginBottom: '0',
  marginLeft: 'auto',
  width: '48px',
  height: '48px',
  display: 'inline-block',
});

export const fairHousingIconCSS = css({
  width: '32px',
  height: '32px',
  margin: '8px',
});

export const fairHousingInfoCSS = css({
  display: 'inline-block',
  paddingTop: '2px',
  marginLeft: '16px',
  width: 'calc(100% - 64px)',
  verticalAlign: 'top',
});

export const homeHubAnimatedFooterCSS = css({
  overflow: 'hidden',
  position: 'relative',
});

export const homeHubAnimatedFooterContentsCSS = css({
  backgroundColor: 'white',
  position: 'relative',
  color: 'hpxBlue600',
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'center',
  height: { base: '196px', md: '484px' },
  left: { base: '50%', xxl: 0 },
  width: { base: '800px', md: '1200px', xl: '2000px', xxl: 'auto' },
  marginLeft: { base: '-400px', md: '-600px', xl: '-1000px', xxl: 0 },
});

export const homeHubAnimatedFooterAnimationCSS = css({
  width: '100%',
});

export const homeHubAnimatedFooterPausePlayButtonCSS = css({
  textAlign: 'center',
  paddingTop: '16px',
});

export const homeHubAnimatedFooterBackgroundCSS = css({
  position: 'absolute',
  bottom: 0,
  left: 0,
  height: { base: '246px', md: 'auto' },
});
